import script from "./UiBackButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiBackButton.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__